export default class InvoiceSearchRequest {
    companyId: string;
    status: number;
    type: number;
    weekCommencingDate: string
}
